/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * RumbleDirect API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorJsonJsonproblem,
  ErrorJsonldJsonld,
  GetRootAffiliates200,
  RootAffiliateResourceAffiliateCreateInputJson,
  RootAffiliateResourceAffiliateCreateOutputJsonld,
  RootAffiliateResourceAffiliateReadDetailsOutputJsonld,
  RootAffiliateResourceAffiliateUpdateInputMergePatchJson,
  ValidationExceptionJsonJson,
  ValidationExceptionJsonldJsonld
} from '../model';

import { customInstance } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get all affiliates
 */
export const getRootAffiliates = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetRootAffiliates200>(
      {url: `/root/affiliates`, method: 'GET', signal
    },
      options);
    }




export const getGetRootAffiliatesQueryKey = () => {
    return [
    `/root/affiliates`
    ] as const;
    }


export const getGetRootAffiliatesQueryOptions = <TData = Awaited<ReturnType<typeof getRootAffiliates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRootAffiliatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRootAffiliates>>> = ({ signal }) => getRootAffiliates(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRootAffiliatesQueryResult = NonNullable<Awaited<ReturnType<typeof getRootAffiliates>>>
export type GetRootAffiliatesQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetRootAffiliates<TData = Awaited<ReturnType<typeof getRootAffiliates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootAffiliates>>,
          TError,
          Awaited<ReturnType<typeof getRootAffiliates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRootAffiliates<TData = Awaited<ReturnType<typeof getRootAffiliates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootAffiliates>>,
          TError,
          Awaited<ReturnType<typeof getRootAffiliates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRootAffiliates<TData = Awaited<ReturnType<typeof getRootAffiliates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all affiliates
 */

export function useGetRootAffiliates<TData = Awaited<ReturnType<typeof getRootAffiliates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRootAffiliatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a new affiliate
 */
export const postRootAffiliates = (
    rootAffiliateResourceAffiliateCreateInputJson: RootAffiliateResourceAffiliateCreateInputJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RootAffiliateResourceAffiliateCreateOutputJsonld>(
      {url: `/root/affiliates`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: rootAffiliateResourceAffiliateCreateInputJson, signal
    },
      options);
    }




export const getPostRootAffiliatesMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRootAffiliates>>, TError,{data: RootAffiliateResourceAffiliateCreateInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postRootAffiliates>>, TError,{data: RootAffiliateResourceAffiliateCreateInputJson}, TContext> => {

const mutationKey = ['postRootAffiliates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRootAffiliates>>, {data: RootAffiliateResourceAffiliateCreateInputJson}> = (props) => {
          const {data} = props ?? {};

          return  postRootAffiliates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostRootAffiliatesMutationResult = NonNullable<Awaited<ReturnType<typeof postRootAffiliates>>>
    export type PostRootAffiliatesMutationBody = RootAffiliateResourceAffiliateCreateInputJson
    export type PostRootAffiliatesMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Create a new affiliate
 */
export const usePostRootAffiliates = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRootAffiliates>>, TError,{data: RootAffiliateResourceAffiliateCreateInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postRootAffiliates>>,
        TError,
        {data: RootAffiliateResourceAffiliateCreateInputJson},
        TContext
      > => {
      return useMutation(getPostRootAffiliatesMutationOptions(options), queryClient);
    }
    /**
 * @summary Get an affiliate by ID
 */
export const getRootAffiliatesId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RootAffiliateResourceAffiliateReadDetailsOutputJsonld>(
      {url: `/root/affiliates/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetRootAffiliatesIdQueryKey = (id: string,) => {
    return [
    `/root/affiliates/${id}`
    ] as const;
    }


export const getGetRootAffiliatesIdQueryOptions = <TData = Awaited<ReturnType<typeof getRootAffiliatesId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliatesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRootAffiliatesIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRootAffiliatesId>>> = ({ signal }) => getRootAffiliatesId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliatesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRootAffiliatesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRootAffiliatesId>>>
export type GetRootAffiliatesIdQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetRootAffiliatesId<TData = Awaited<ReturnType<typeof getRootAffiliatesId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliatesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootAffiliatesId>>,
          TError,
          Awaited<ReturnType<typeof getRootAffiliatesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRootAffiliatesId<TData = Awaited<ReturnType<typeof getRootAffiliatesId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliatesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootAffiliatesId>>,
          TError,
          Awaited<ReturnType<typeof getRootAffiliatesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRootAffiliatesId<TData = Awaited<ReturnType<typeof getRootAffiliatesId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliatesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an affiliate by ID
 */

export function useGetRootAffiliatesId<TData = Awaited<ReturnType<typeof getRootAffiliatesId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootAffiliatesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRootAffiliatesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The slug and features cannot be changed through this operation.
 * @summary Update an affiliate
 */
export const patchRootAffiliatesId = (
    id: string,
    rootAffiliateResourceAffiliateUpdateInputMergePatchJson: RootAffiliateResourceAffiliateUpdateInputMergePatchJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RootAffiliateResourceAffiliateReadDetailsOutputJsonld>(
      {url: `/root/affiliates/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: rootAffiliateResourceAffiliateUpdateInputMergePatchJson, signal
    },
      options);
    }




export const getPatchRootAffiliatesIdMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchRootAffiliatesId>>, TError,{id: string;data: RootAffiliateResourceAffiliateUpdateInputMergePatchJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchRootAffiliatesId>>, TError,{id: string;data: RootAffiliateResourceAffiliateUpdateInputMergePatchJson}, TContext> => {

const mutationKey = ['patchRootAffiliatesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchRootAffiliatesId>>, {id: string;data: RootAffiliateResourceAffiliateUpdateInputMergePatchJson}> = (props) => {
          const {id,data} = props ?? {};

          return  patchRootAffiliatesId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchRootAffiliatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchRootAffiliatesId>>>
    export type PatchRootAffiliatesIdMutationBody = RootAffiliateResourceAffiliateUpdateInputMergePatchJson
    export type PatchRootAffiliatesIdMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Update an affiliate
 */
export const usePatchRootAffiliatesId = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchRootAffiliatesId>>, TError,{id: string;data: RootAffiliateResourceAffiliateUpdateInputMergePatchJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchRootAffiliatesId>>,
        TError,
        {id: string;data: RootAffiliateResourceAffiliateUpdateInputMergePatchJson},
        TContext
      > => {
      return useMutation(getPatchRootAffiliatesIdMutationOptions(options), queryClient);
    }
